import { PressEvent } from "react-aria-components";
import { Button } from "../../Common/Buttons/Button";

export interface PropertyOptionsButtonProps {
  onPress: (_: PressEvent) => void;
  disabled?: boolean;
  showCaret?: boolean;
}

const PropertyOptionsButton = ({
  onPress,
  disabled,
  showCaret = true,
}: PropertyOptionsButtonProps) => (
  <Button
    onPress={onPress}
    size="small"
    variant="outlineInverted"
    isDisabled={disabled}
    iconEnd={showCaret ? "chevron-down" : undefined}
    title="Edit property"
  />
);

export default PropertyOptionsButton;
